let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("42DUg")).then(() => parcelRequire('49kmy'));